import { makeStyles } from '@material-ui/core/styles'

export const useAccountCreationCompletionStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: '0 auto',
    maxWidth: '720px',
    padding: '32px 24px 48px',
  },
  instructions: {
    width: '100%',
    marginBottom: '32px',
    fontFamily: 'Nunito, sans-serif',
    fontSize: '22px',
    lineHeight: '28px',
    fontWeight: 400,
    color: '#44474F',
    textAlign: 'center',
    '& p': {
      margin: '0 0 12px',
      '&:last-child': {
        marginBottom: 0,
      },
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '14px',
      lineHeight: '20px',
      marginBottom: '24px',
    },
  },
  saveCredentials: {
    fontStyle: 'italic',
    fontWeight: 700,
  },
  credentialsBox: {
    width: '100%',
    maxWidth: '420px',
    padding: '32px 40px',
    border: '3px solid #4C8DE8',
    borderRadius: '12px',
    [theme.breakpoints.down('sm')]: {
      padding: '24px 20px',
    },
  },
  credentialsHeading: {
    margin: '0 0 28px',
    fontFamily: 'Nunito, sans-serif',
    fontWeight: 400,
    fontSize: '22px',
    lineHeight: '28px',
    color: '#44474F',
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      fontSize: '16px',
      lineHeight: '24px',
      marginBottom: '20px',
    },
  },
  field: {
    marginBottom: '24px',
    '&:last-child': {
      marginBottom: 0,
    },
  },
  fieldLabel: {
    display: 'block',
    marginBottom: '4px',
    fontFamily: 'Nunito, sans-serif',
    fontWeight: 700,
    fontSize: '16px',
    lineHeight: '24px',
    color: '#0F5DB5',
  },
  fieldValue: {
    fontFamily: 'Nunito, sans-serif',
    fontSize: '16px',
    lineHeight: '24px',
    color: '#74777F',
    wordBreak: 'break-all',
  },
  passwordRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '12px',
  },
  passwordValue: {
    fontFamily: 'Nunito, sans-serif',
    fontSize: '16px',
    lineHeight: '24px',
    color: '#74777F',
    letterSpacing: '2px',
  },
  visibilityButton: {
    flexShrink: 0,
    padding: '4px',
    color: '#0F5DB5',
  },
}))
